module.exports = __webpack_public_path__ + "produce-fresh-grass-07.jpg?1aecccb140d7f5c32f0dc2bf8d3ec163";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-07.jpg
// module id = 44
// module chunks = 0